import { render, staticRenderFns } from "./EditarIndicacion.vue?vue&type=template&id=70930de6&scoped=true"
import script from "./EditarIndicacion.vue?vue&type=script&lang=js"
export * from "./EditarIndicacion.vue?vue&type=script&lang=js"
import style0 from "./EditarIndicacion.vue?vue&type=style&index=0&id=70930de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70930de6",
  null
  
)

export default component.exports